import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { detectLandingType, LandingType } from "@/utils/routing/landingDetection";
import { ConsumerHomePage } from "./Consumer";
import HomePage from "./index"; // Business homepage

/**
 * Smart homepage component that chooses between business and consumer landing
 * based on URL detection (app.helpgenie.com or /consumer path)
 */
export default function SmartHomePage() {
  const { pathname } = useLocation();
  const [landingType, setLandingType] = useState<LandingType>(() => detectLandingType());

  useEffect(() => {
    setLandingType(detectLandingType());
  }, [pathname]);

  // Show consumer landing for app.helpgenie.com or /consumer paths
  if (landingType === "consumer") {
    return <ConsumerHomePage />;
  }

  // Default: show business landing
  return <HomePage />;
}
